import { ILedgerHistoryFilters } from './types'

export const EMPTY_KINDS_ERROR = 'Не выбран ни один тип операции'

// undefined — фильтра типа нет на экране (справочник не загрузился), это не пустой выбор.
export const ledgerHistoryFiltersError = (filters: ILedgerHistoryFilters): string | null =>
  filters.kinds !== undefined && filters.kinds.length === 0 ? EMPTY_KINDS_ERROR : null
